import { getSimilarVehicles } from 'Services/api/vehicles';
import type { GetSimilarVehiclesResponse } from 'Services/api/vehicles.types';
import type { EnquiryState } from 'Types/enquiryStates';
import type { Vehicle } from 'Types/vehicle';

export type SimilarVehiclesFetcherParams = {
	enquiryId: number;
	make: Vehicle['spec']['make'];
	model: Vehicle['spec']['model'];
	stateSlug: EnquiryState['slug'];
};

export const similarVehiclesFetcher = async ({
	enquiryId,
	make,
	model,
	stateSlug,
}: SimilarVehiclesFetcherParams): Promise<GetSimilarVehiclesResponse> =>
	getSimilarVehicles({
		enquiryId,
		make,
		model,
		stateSlug,
	});
